const allCategories = require('../data/categories.json');
const fetchWordpress = require('../api/wordpress');

function findTemplates(acf) {
  return Object.keys(acf)
    .filter(key => key.includes('templates'))
    .map(template => acf[template])
    .reduce((acc, template) => (template ? [...acc, ...template] : acc), []);
}

function postData(page) {
  if (!page) return {};
  const { acf, categories: postCategories, date, title, slug } = page;
  const { post_type, default_fields, custom_asides, asides_list } = acf;
  const categories = postCategories ? postCategories.map(cat => allCategories[cat].name) : [];
  const post_fields =
    {
      post_fields: {
        ...default_fields,
        date,
        categories,
        title: title.rendered,
        slug,
        meta: {
          title: acf.title,
          description: acf.description,
          canonical: acf.canonical,
          ogimage: acf.ogimage
        },
      }
    } || {};
  const postTemplates =
    post_type === 'default' ? { post_templates: findTemplates(default_fields) } : {};
  const asides = asides_list && asides_list.map(({ post_id }) => post_id.post_name);
  const postAsides = {
    custom_asides,
    asides_list: asides
  };
  return {
    ...postTemplates,
    ...post_fields,
    ...postAsides,
  };
}

function pageData(page, cb) {
  if (!page) return {};
  const callbackProps = cb ? cb(page) : {};
  const { acf, id, title, type, parent } = page;
  const { page_type, asides_list, page_attributes } = acf;
  const templates = findTemplates(acf);
  const postProps = type === 'post' ? postData(page) : {};
  const asides = asides_list && asides_list.map(({ post_id }) => post_id.post_name);
  const pageAsides = {
    asides_list: asides,
  };
  return {
    slug: page.slug === 'home' ? '/' : `/${page.slug}`,
    parent,
    id,
    type,
    page_title: title.rendered,
    page_type,
    page_attributes,
    meta: {
      title: acf.title,
      description: acf.description,
      canonical: acf.canonical,
      ogimage: acf.ogimage
    },
    templates: page.acf.templates || templates,
    ...postProps,
    ...callbackProps,
    ...pageAsides
  };
}
async function getAsideProps(aside_list) {
  const pendingAsides = aside_list.map(async (aside) => {
    const asideID = aside.post_id.ID;
    const asideData = await fetchWordpress(`posts/${asideID}`);
    const { acf } = asideData;
    const { aside_type } = acf;
    return {
        acf_fc_layout: `aside-${acf.aside_type}`,
        ...acf[aside_type]
    };
  });
  const asides = await Promise.all(pendingAsides);
  return asides;
}

async function templateData(page) {
  if (!page) return {};
  const { acf } = page;
  // consolidate all templates
  const templates = Object.keys(acf)
    .filter(key => key.includes('templates'))
    .map(
      template =>
        acf[template] &&
        acf[template].map(component => ({
          ...component,
          templateType: template.replace('_', '-')
        }))
    )
    .reduce((acc, template) => (template ? [...acc, ...template] : acc), []);

  const pendingMappedTemplates = templates.map(async template => {
    const { acf_fc_layout, templateType, templates_shared, ...props } = template;
    try {
      if (acf_fc_layout === 'with_aside') {
          const pendingWAsideTemplates = templates_shared.map(async template => {
            try {
              const templatePath = `templates-shared/${
                template.acf_fc_layout
              }/initial-props`;
              const { getInitialProps } = require(`../src/components/${templatePath}`);
              const templateProps = await getInitialProps(template);
              return { ...template, ...templateProps, w_aside: true };
            } catch (error) {
              return template;
            }
          });
          const mappedWAsideTemplates = await Promise.all(pendingWAsideTemplates);
          const aside_list = await getAsideProps(template.aside_list);
          return {
            ...template,
            templates: mappedWAsideTemplates,
            aside_list
          };
      }
        const templatePath = `${templateType}/${acf_fc_layout}/initial-props`;
        const { getInitialProps } = require(`../src/components/${templatePath}`);
        const templateProps = await getInitialProps(props);
        return {
          ...template,
          ...templateProps
        };
    } catch (e) {
      return template;
    }
  });
  const mappedTemplates = await Promise.all(pendingMappedTemplates);
  return {
    ...page,
    acf: {
      ...page.acf,
      templates: mappedTemplates
    }
  };
}

module.exports = {
  pageData,
  postData,
  templateData
};
